import { APP_NAME } from '../constants'
import { composeStartParam } from '../functions/startParam'

/**
 * Get BOT_USERNAME from environment, throws if not defined
 * @throws {ShareConfigError} If BOT_USERNAME is not defined
 */
const getBotUsername = (): string => {
  const botUsername = process.env.BOT_USERNAME
  if (!botUsername) {
    throw new Error('BOT_USERNAME is not defined in environment variables')
  }
  return botUsername
}

/**
 * Generate a referral URL for sharing
 * Format: https://t.me/{BOT_USERNAME}/{APP_NAME}?startapp=ref_{referralKey}
 *
 * @param referralKey - Referral key (user's referral identifier)
 * @returns Referral URL
 * @throws {ShareConfigError} If BOT_USERNAME is not defined
 *
 * @example
 * generateReferralUrl('548357ea')
 * // Returns: 'https://t.me/VoteBoxBot/votebox?startapp=ref_548357ea'
 */
export const generateReferralUrl = (referralKey: string): string => {
  const botUsername = getBotUsername()
  const startParam = composeStartParam(referralKey, null)
  return `https://t.me/${botUsername}/${APP_NAME}?startapp=${startParam}`
}

/**
 * Generate a box deep link for sharing
 * Format: https://t.me/{BOT_USERNAME}/{APP_NAME}?startapp={startParam}
 * Start param includes optional referral key and box ID
 *
 * @param boxId - Box ID to share
 * @param referralKey - Optional referral key to track the share
 * @returns Box deep link URL
 * @throws {ShareConfigError} If BOT_USERNAME is not defined
 *
 * @example
 * generateBoxDeepLinkUrl(123, 'abc-def-ghi')
 * // Returns: 'https://t.me/VoteBoxBot/votebox?startapp=ref_abc-def-ghi_box_123'
 *
 * @example
 * generateBoxDeepLinkUrl(123)
 * // Returns: 'https://t.me/VoteBoxBot/votebox?startapp=box_123'
 */
export const generateBoxDeepLinkUrl = (
  boxId: number,
  referralKey?: string | null,
): string => {
  const botUsername = getBotUsername()
  const startParam = composeStartParam(referralKey || null, boxId)
  return `https://t.me/${botUsername}/${APP_NAME}?startapp=${startParam}`
}
